export default Object.freeze({
  SERVING: 'ADF',
  EX_SERVING: 'ExServing',
  WORK_CONNECTION: 'WorkConnection',
  RELATED: 'Supporting',
});
